import axios from 'axios'
import apiUrl from '../../../constants'
import CryptoJS from 'crypto-js'
import VueElementLoading from 'vue-element-loading'
import Validator from 'vee-validate'
import PageTracker from '../../../common/PageTrackerHelper'
import Paginate from 'vuejs-paginate'
import { BasicSelect } from 'vue-search-select'
import rvpInscanPending from '../common/rvpInscanPending.vue'
import shortageShipments from '../common/shortageShipments.vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import RVPPrintLabelReviewv2 from '../RVPPrintLabelReviewv2/index.vue';
import { updateShipmentStatusForOnePager, getStickerRestrictionFlag, varifyAndLinkShipmentAndFlyerBarcodeOnePager, fetchShipmentLabelData } from "../../../../services/modules/printlabelservices.js";
import moment from 'moment'

export default {
  name: 'InScanRVPShipments',
  components: {
    VueElementLoading,
    CryptoJS,
    Paginate,
    BasicSelect,
    'pending-InscanRVP': rvpInscanPending,
    'shortage-shipments': shortageShipments,
    FormWizard,
    TabContent,
    RVPPrintLabelReviewv2
  },
  props: {
    propsParam: String  // Define the type of the prop
  },
  mixins: [PageTracker],
  data() {
    return {
      flyerBarcode: '',
      weightType: '',
      length: '',
      breadth: '',
      height: '',
      physicalWeight: '',
      searchByShippingId: '',
      searchByShippingIdForShortage: '',
      shipmentType: '',
      searchByShippingIdMdl: '',
      shortageShippingIdMdl: '',
      hubid: null,
      pageNo: 1,
      pageNumber: 1,
      pagecount: 0,
      pageCount: 0,
      pageCountForShortage: 0,
      pageCountForShortageMdl: 0,
      pendingShipmentList: [],
      pendingShipmentListMdl: [],
      shortageShipmentListMdl: [],
      weightTypeOptions: [
        {
          text: '--Not Mandatory--',
          value: "NVW"
        },
        {
          text: 'Polybag',
          value: "PB"
        },
        {
          text: 'Custom-Polybag',
          value: "CP"
        },
        {
          text: 'Custom-Boxes',
          value: "CB"
        }
      ],
      selectedWeight: {},
      input: {},
      shipmentBarcode: '',
      openDimentionWeightTab: false,
      pendingShipmentModel: false,
      isPendingShipmentLoading: true,
      isPendingShipmentLoadingMdl: false,
      showSearchBar: false,
      onDimentionTabValidation: false,
      showPaginate: false,
      showShortagePaginate: false,
      isConfirmPhyWt: false,
      isConfirmVolWt: false,
      formLoading: false,
      flag: false,
      showPWcheckBox: false,
      showVWcheckBox: false,
      mdlFlag: true,
      shortageShipmentList: [],
      totalShipments: 0,
      total: 0,
      showShortagePaginateMdl: false,
      pageNoShortage: 1,
      pageNumShortageMdl: 1,
      isShortageShipmentLoadingMdl: false,
      shortageShipmentMdl: false,
      totalShortageShipMDl: null,
      shortageShippingMdl: '',
      modalType: 'RVP',
      ActiveTabIndex: 0,
      total3: '',
      checkTLQCProcessModal: false,
      QuestionObjList: [],
      isLoadingScanShipmentsTLQC: false,
      Savebuttondisable: true,
      isLoadingupload: false,
      shippingId: '',
      RVPShipment: '',
      Answer: [],
      RVPQCTable: [],
      isLoadingQc: false,
      isLoadingGetQuestions: false,
      isLoadingsave: false,
      isLoadingScanShipmentsTLQC: false,
      QcQuestionAns: {},
      QCSRValues: [],
      uploadMultipleImageModal: false,
      QuestionsObj: { Label: "", Type: "" },
      AnswerInradio: false,
      AnswerIntext: false,
      AnswerInnumber: false,
      AnswerType: '',
      QuestionObjList: [],
      TextAns: '',
      NumberAns: '',
      countAnswer: [],
      QuestionObjListSrValue: [],
      Savebuttondisable: true,
      // imageCount: 0,
      UploadedImgCount: 0,
      checkUploadImg: 0,
      srLoader: '',
      SetReadonlyMode: true,
      ClientPickupProductImages: [],
      SRPickDoneImages: [],
      IsClientPickImages: false,
      IsSRPickImages: false,
      UploadedImageArr: [],
      DeleteURL: '',
      openUploadImg: true,
      UploadImgLoader: false,
      UploadFilArr: [],
      loader: '<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
      currentTabTitle: '',
      currentStep: 0,
      NewRES: [],
      ProductDetails: [],
      isSKUDAta: [],
      TabArray: [],
      themecolor: '#20a8d8',
      stepIndex: 0,
      inscanBtnDisabled: false,
      IsFlyerJacketEnabled: false,
      IsPrinterAvailable: true,
      IsRtoRestrict: false,
      isShipInputBoxShown: true,
      restrictTLQCModal: false,
      restrictTLQCError: '',
      userDataKey: '',
      timeout: null,
      isManualEntryRestrict: false,
      ttl: '',

      /* Props */
      actionStatus: "",

      /* Move Screen Flag */
      screen: '2',

      /* Pass param to another component */
      propsParameter: {},

      /* Show the Reprint Popup */
      isShowReprintPopUp: false,

      /* shipmentData */
      shipResponseData: '',

      /* Printer Selection */
      isSelectPrinter: '0',
      selected: '',
      prnData: '',
      isLoading: false,

      /* Restirct */
      isShowReprintPopUpReprint: false,

      /* Is DTO Paper Sheet On OFf */
      isDtoPaperSheetOnOrOff: false,

      ttl:"",
      rePrintCount:""
    }
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userrole = userdetail.userrole[0].rolename;
    this.userid = userdetail.userid
    this.localusermailid = userdetail.username;
    this.hubid = userdetail.hubdetails[0]
    this.outsourcingid = userdetail.outsourcingid
    this.localuserEmail = userdetail.email;
    // this.flyerBarcode = this.propsParam.shipmentDetails.Flyerbarcode;
    this.RVPShipment = this.propsParam.shipmentDetails.ShippingId;
    this.shipResponseData = this.propsParam.shipmentDetails;
    this.rePrintCount = this.propsParam.rePrintCount;
    
    if (this.shipResponseData.paperSheetDetails) {
      this.selected = '0' // For DTO PaperSheet
    }
    else {
      this.selected = '1' // For RTO/DTO Stricker Printing
    }

    await this.checkStickerRestriction();
    this.getPendingShipmentListForPickupDone();
    //scanner detection code
    if (!this.isManualEntryRestrict) {
      if (process.env.NODE_ENV === 'production') {
        let keyupFiredCount = 0
        var vm = this;
        $("#clearShipmentBarcode").keyup(this.DelayExecution(function (event) {
          let keycode = (event.keyCode ? event.keyCode : event.which);
          keyupFiredCount = keyupFiredCount + 1;
        }));

        $("#clearShipmentBarcode").blur(function (event) {
          if ($("#clearShipmentBarcode").val() == '') {
            return false;
          }
          if (keyupFiredCount <= 1) {
            vm.IsmannulCheck('B');
          } else {
            vm.IsmannulCheck('M');
          }
          keyupFiredCount = 0;
        });
      }
    }
    //scanner detection code

    /* action status will show the inscan or linking. */
    this.actionStatus = (this.propsParam.actionStatus ) ? this.propsParam.actionStatus : (this.propsParam.shipmentDetails.dbDetails.status) ? this.propsParam.shipmentDetails.dbDetails.status : "";
    this.propsParameter = this.propsParam;
  },
  watch: {
    stepIndex(val) {
      this.currentTabTitle = this.NewRES[val].ProductID
      console.log("this.currentTabTitle", this.currentTabTitle);
      this.GetUploadedImages();
    }
  },

  methods: {

    /* Check Hub Restriction Flag */
    async checkStickerRestriction() {
      let payload = {
        "HubId": this.hubid,
        "isPrinterAvailableCheck": true
      }
      await getStickerRestrictionFlag(payload, (result) => {
        try {
          if (result.data.code == 200) {
            this.IsPrinterAvailable = result.data.data[0].isdtorestrictprinting;
            this.IsFlyerJacketEnabled = result.data.data[0].isflyerjacketenabled;
            this.IsRtoRestrict = result.data.data[0].isrtorestrictprinting
          }
          else {
            this.IsPrinterAvailable = true;
            this.IsFlyerJacketEnabled = false;
            this.IsRtoRestrict = false;
          }
          this.isShipmentInputBoxShown();
          this.ttl = result && result.data && result.data.restrictionRes.ttl ? result.data.restrictionRes.ttl : 200;
          this.isManualEntryRestrict = result && result.data && result.data.restrictionRes.isRestriction ? result.data.restrictionRes.isRestriction : false;
        } catch (e) {
          console.log('result-----<<<<-', e);
        }
      })
    },

    isShipmentInputBoxShown() {
      if (this.IsPrinterAvailable == false) {
        this.isShipInputBoxShown = false;
      }
      else {
        this.isShipInputBoxShown = true;
      }
    },


    /* Inscan Shipment */
    submitForm(scope) {

      if (this.showPWcheckBox && this.isConfirmPhyWt === false) {
        this.$alertify.error("Please Confirm Physical Weight")
        this.isConfirmPhyWt = false
        return false
      } else if (this.physicalWeight > 150) {
        this.$alertify.error("Physical weight of an E-Com shipment cannot be more than 150 Kgs")
        return false
      }
      if ((this.length * this.breadth * this.height) / 6000 >= 20) {
        this.showVWcheckBox = true
        if (this.showVWcheckBox && this.isConfirmVolWt === false) {
          this.$alertify.error("Please Confirm Volumetric Weight")
          return false
        }
      } else {
        this.isConfirmVolWt = false
        this.showVWcheckBox = false
      }
      if(this.flyerBarcode != this.propsParam.shipmentDetails.Flyerbarcode){
        this.$alertify.error("FlyerBarcode Mismatch")
        return false
      }
      if(this.IsPrinterAvailable && this.shipmentBarcode != this.propsParam.shipmentDetails.ShippingId){
        this.$alertify.error("ShippingID Mismatch")
        return false
      }
      this.$validator.validateAll(scope).then(res => {
        if (res) {
          // this.shipmentInScanForRVP2();
          let ShippingId = this.propsParam.shipmentDetails.ShippingId;
          this.ScanShipmentsTLQC(ShippingId);
        } else {
          this.$alertify.error("Invalid Input Data")
          return false
        }
      }).catch(err => {
        console.log("Error Details", err);
        return false
      })
    },
    submitFormLinking(scope) {

      this.$validator.validateAll(scope).then(res => {
        if (res) {

          let inscan_payload = {
            "shippingId": this.shipmentBarcode.toString(),
            "flyerBarCode": this.flyerBarcode,
            "modifiedby": this.localuserEmail
          }

          varifyAndLinkShipmentAndFlyerBarcodeOnePager(inscan_payload, (result) => {
            try {
              if (result.data.code == 200) {
                this.$alertify.success(result.data.message)
                /* Calling Update API Here */
                let RequestForNewPrint = {
                  "hubid": this.hubid,
                  "requestedby": this.userid,
                  "requestsource": "lm",
                  "shippingid": this.shipmentBarcode.toString(),
                  "shipmenttype": this.propsParam.shipmentDetails.shipmentType,
                  "centertype": this.propsParam.shipmentDetails.centerType,
                  "istlqceligible": this.propsParam.shipmentDetails.isTlqcShipment,
                  "istlqcdone": this.propsParam.shipmentDetails.hasTlqcProcessCompleted,
                  "userrole": this.userrole.toString(),
                  "action": "linkingdone"
                }
                updateShipmentStatusForOnePager(RequestForNewPrint, (result) => {
                  try {
                    /* reset All Fields */
                    if (result.data.code == 200) {
                      this.$alertify.success(result.data.message);
                      setTimeout(() => {
                        window.location.reload();
                      }, 2000); // 10000 milliseconds = 10 seconds
                    } else {
                      this.$alertify.error(result.data.message);
                    }
                  } catch (error) {
                    console.log('result------', error.message);
                  }
                })
              } else {
                this.$alertify.error(result.data.message)
              }
            } catch (error) {
              console.log("----" + error.message);
            }
          })
        } else {
          this.$alertify.error("Invalid Input Data")
          return false
        }
      })
    },
    ScanShipmentsTLQC(ShippingId) {
      this.RVPShipment = ShippingId;
      if (this.RVPShipment == '') {
        this.$alertify.error("Please enter ShippingId")
      }
      else {
        this.input = {
          "ShippingID": this.RVPShipment.trim(),
          "LastModifiedBy": this.localusermailid,
          "IsInscan": true,
          "IsRVPQCCheck": true
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'DayEndClosure/updateEODInscanShipment',
          data: this.input
        })
          .then(response => {
            if (response.data.code == 200 || response.data.data.ScanMessage == "Shipment already scanned in Day End Closure" || response.data.data.ScanMessage == "Shipment is not eligible for Day End Closure") {

              this.isLoadingScanShipmentsTLQC = false;
              this.manualshipmentinscanforrvp(this.RVPShipment);
              
            }
            else {
              this.isLoadingScanShipmentsTLQC = false;
              this.$alertify.error(response.data.data.ScanMessage);
             
            }
            this.reset()
            this.srLoader = ''
            return true
          })
      }
    },

    manualshipmentinscanforrvp(ShippingId) {
      var payload = {}
      if (this.weightType === "NVW" || this.weightType === "PB" || this.weightType === "") {
        payload = {
          shippingID: ShippingId.toString(),
          flyerBarcode: this.flyerBarcode,
          originHubID: this.hubid,
          lastModifiedBy: this.localusermailid,
          physicalWeight: 0,
          shipmentLength: 0,
          shipmentBreadth: 0,
          shipmentHeight: 0,
          isConfirmInScan: true,
          isConfirmPhyWt: false,
          isConfirmVolWt: false,
          inScanFromDevice: this.weightType === "PB" ? "PB" : "NVW",
          statusMarkedFrom: "web",
          inscanType: 1
        }
      }
      if (this.weightType === "CB" || this.weightType === "CP") {
        payload = {
          shippingID: ShippingId.toString(),
          flyerBarcode: this.flyerBarcode,
          originHubID: this.hubid,
          lastModifiedBy: this.localusermailid,
          physicalWeight: this.physicalWeight,
          shipmentLength: this.length,
          shipmentBreadth: this.breadth,
          shipmentHeight: this.height,
          isConfirmInScan: true,
          isConfirmPhyWt: this.isConfirmPhyWt,
          isConfirmVolWt: this.isConfirmVolWt,
          inScanFromDevice: (this.weightType === "CB" ? "CB" : "CP"),
          statusMarkedFrom: "web",
          inscanType: 1
        }
      }
      this.formLoading = true
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'rvpinscanshipment/manualshipmentinscanforrvp',
        data: payload
      }).then(res => {
        //this.reset()
        this.formLoading = false
        if (res.data.code === 200) {
          let TrackerInfo = {
            projectname: "Lastmile-web",
            type: "Web",
            userid: this.userid,
            username: this.localusermailid,
            meta: {
              "event": "manualShipmentInscanForRvp",
              "ShippingID": ShippingId.toString(),
              "flyerBarcode": this.flyerBarcode
            }
          }
          this.PageTracker(TrackerInfo);
          this.$alertify.success(res.data.message)
          /* Calling Update API Here */
          let RequestForNewPrint = {
            "hubid": this.hubid,
            "requestedby": this.userid,
            "requestsource": "lm",
            "shippingid": ShippingId.toString(),
            "shipmenttype": this.propsParam.shipmentDetails.shipmentType,
            "centertype": this.propsParam.shipmentDetails.centerType,
            "istlqceligible": this.propsParam.shipmentDetails.isTlqcShipment,
            "istlqcdone": this.propsParam.shipmentDetails.hasTlqcProcessCompleted,
            "userrole": this.userrole,
            "action": "inscandone"
          }
          updateShipmentStatusForOnePager(RequestForNewPrint, (result) => {
            try {
              /* reset All Fields */
              if (result.data.code == 200) {
                this.$alertify.success(result.data.message);
                this.propsParameter.actionStatus = result.data.status;
                this.screen = 3;
              } else {
                this.$alertify.error(result.message);
              }
            } catch (error) {
              console.log('result------', error.message);
            }
          })

          //this.ScanShipmentsTLQC(ShippingId);
          this.reset()
          this.srLoader = ''
          return true
        } else {
          this.$alertify.error(res.data.message)
          this.srLoader = ''
          // this.shipmentBarcode = '';
          this.flyerBarcode = '';
          document.getElementById('clearFlyerBarcode').value = '';
          if (this.IsPrinterAvailable == true) {
            this.$refs.clearShipmentBarcode.focus();
          }
          else {
            this.$refs.clearFlyerBarcode.focus();
          }
          return false
        }
      }).catch(err => {
        this.formLoading = false
        console.log("Error Details", err);
        return false
      })
    },


    // async validateFormData() {
    //   let scope = `formw_${this.stepIndex}`;
    //   let val = await this.$validator.validateAll(scope);
    //   if (!val) {
    //     this.$alertify.error("All fields should be mandatory");
    //   }
    //   else if (this.UploadedImgCount != 4) {
    //     this.$alertify.error("4 Images are required!")
    //     return false;
    //   }
    //   return val;
    // },
    IsmannulCheck(ScanType) {
      if (ScanType == 'B') {

      } else {
        // this.shipmentBarcode = '';
        // this.$refs.clearShipmentBarcode.focus();
        this.$alertify.error('Mannual input is not allowed. Use Barcode scanner.!');
      }
      console.log('ScanType', ScanType);
    },
    DelayExecution(f, delay) {
      var timer = null;
      return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = window.setTimeout(function () {
          f.apply(context, args);
        },
          delay || 30);
      };
    },
    changeTabPosition(event) {
      var charCode = (typeof event.which == "number") ? event.which : event.keyCode;
      if (/\D/.test(String.fromCharCode(charCode))) {
        this.$refs.clearFlyerBarcode.focus();
        return false;
      }
    },
    getShortageShipmentList() {
      this.isPendingShipmentLoading = true
      if (this.searchByShippingId) {
        document.getElementById('clearSearchField').value = '';
        this.searchByShippingId = ''
      }
      this.reqPayload = {
        "HubID": this.hubid,
        "ShipmentStatus": "SAReturnPending",
        "PageNo": this.searchByShippingIdForShortage ? 1 : this.pageNoShortage,
        "PageSize": 10,
        "ShipmentType": 'Reverse'
      }
      if (this.outsourcingid) {
        this.reqPayload.OutSourcingMasterId = this.outsourcingid;
      }
      if (this.searchByShippingIdForShortage) {
        this.reqPayload.ShippingID = this.searchByShippingIdForShortage;
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'rvpinscanshipment/getsareturnpendingagainsthub',
        data: this.reqPayload
      }).then(result => {
        this.isPendingShipmentLoading = false;
        this.showShortagePaginate = true;
        if (result.data.code === 200) {
          this.totalShipments = result.data.result.TotalShipments
          this.shortageShipmentList = result.data.result.Shipments

          if (this.totalShipments < 10) {
            this.pageCountForShortage = 1
          } else {
            this.pageCountForShortage = Math.ceil(this.totalShipments / 10)
          }
        } else if (result.data.code === 202) {
          this.$alertify.error("No Data Found");
          return false;
        } else {
          this.$alertify.error(result.data.message);
          return false;
        }
      }).catch(error => {
        this.isPendingShipmentLoading = false;
        console.log("Error Details", error);
        return false
      })
    },
    switchTab(type) {
      this.modalType = type;

      if (type === 'RVP') {
        this.getPendingShipmentListForPickupDone()
      } else {
        this.getShortageShipmentList()
      }

    },
    async getPendingShipmentListForPickupDone() {
      this.isPendingShipmentLoading = true
      this.shipmentType = 'Reverse'
      if (this.searchByShippingIdForShortage) {
        document.getElementById('clearShortageSearchField').value = '';
        this.searchByShippingIdForShortage = ''
      }
      this.input = {
        "HubId": this.hubid,
        "PageNo": this.searchByShippingId ? 1 : this.pageNo,
        "ShipmentType": this.shipmentType,
        // "ShippingId":
      }
      if (this.searchByShippingId) {
        this.input.ShippingId = this.searchByShippingId
      }
      await axios({
        method: 'POST',
        url: apiUrl.api_url + 'rvpinscanshipment/getpendingshipmentlist',
        data: this.input
      }).then(async res => {
        // console.log("List--",res);
        this.isPendingShipmentLoading = false
        this.showPaginate = true
        this.isPendingShipmentLoadingMdl = false
        this.showSearchBar = true
        if (res.data.code === 204) {
          this.$alertify.error(res.data.message)
          return false
        }
        this.pendingShipmentList = res.data.data
        this.isPendingShipmentLoading = false
        if (this.mdlFlag) {
          this.pendingShipmentListMdl = res.data.data
        }
        this.total = res.data.total;
        this.total3 = res.data.total;
        if (this.total < 10) {
          this.pagecount = 1
          this.pageCount = 1
        } else {
          this.pagecount = Math.ceil(this.total / 10)
          this.pageCount = Math.ceil(this.total / 10)
        }
      }).catch(err => {
        this.showSearchBar = true
        this.isPendingShipmentLoading = false
        this.isPendingShipmentLoadingMdl = false
        console.log("Error Details", err);
        return false
      })
    },

    SelectWeight(cls) {
      this.weightType = cls.value
      this.selectedWeight = cls
      if (this.weightType === "PB" || this.weightType === "NVW") {
        this.openDimentionWeightTab = false
        this.onDimentionTabValidation = false
        this.$validator.reset()
        this.length = ''
        this.breadth = ''
        this.height = ''
        this.physicalWeight = ''
        document.getElementById("lengthid").value = ''
        document.getElementById("breadthid").value = ''
        document.getElementById("heightid").value = ''
        document.getElementById("physicalWeightId").value = ''
        this.showPWcheckBox = false
        this.isConfirmPhyWt = false
      } else {
        this.openDimentionWeightTab = true
        this.onDimentionTabValidation = true
      }
    },
    openModelPendingShipmentList(tab) {
      if (tab === 'RVP') {
        this.mdlFlag = false
        this.pendingShipmentModel = true
        if (this.flag) {
          this.flag = false
          this.getShipmentbyShippingIdMdl()
        }
      } else {
        this.shortageShipmentMdl = true
        this.isShortageShipmentLoadingMdl = true;
        this.getShortageShipmentListMdl();
      }
    },
    closePendingShipmentModel(tabtype) {
      if (tabtype === 'RVPMdl') {
        this.pendingShipmentModel = false
        if (this.searchByShippingIdMdl) {
          document.getElementById('clearSearchFieldMdl').value = ''
          this.searchByShippingIdMdl = ''
          this.flag = true
        }
      } else {
        this.shortageShipmentMdl = false
        if (this.shortageShippingIdMdl) {
          document.getElementById('ShortageShippingMdl').value = ''
          this.shortageShippingIdMdl = ''
        }
      }

    },
    getPaginationData(pageNum) {
      this.pageNo = pageNum
      if (this.searchByShippingId) {
        document.getElementById('clearSearchField').value = '';
        this.searchByShippingId = ''
      }
      this.getShipmentbyShippingId()
    },
    getPaginationDataForShortage(pageNum) {
      this.pageNoShortage = pageNum
      if (this.searchByShippingIdForShortage) {
        document.getElementById('clearShortageSearchField').value = '';
        this.searchByShippingIdForShortage = ''
      }
      this.getShortageShipmentList()
    },
    getPaginationDataMdl(pageNum) {
      this.pageNumber = pageNum
      if (this.searchByShippingIdMdl) {
        document.getElementById('clearSearchFieldMdl').value = '';
        this.searchByShippingIdMdl = ''
      }
      this.getShipmentbyShippingIdMdl()
    },
    getShortagePaginationData(pageNo) {
      this.pageNumShortageMdl = pageNum
      if (this.shortageShippingIdMdl) {
        document.getElementById('ShortageShippingMdl').value = ''
        this.shortageShippingIdMdl = ''
      }
      this.getShortageShipmentListMdl();
    },
    getShipmentbyShippingId() {

      this.isPendingShipmentLoading = true
      this.shipmentType = 'Reverse'
      this.input = {
        "HubId": this.hubid,
        "PageNo": this.searchByShippingId ? 1 : this.pageNo,
        "ShipmentType": this.shipmentType,
        // "ShippingId": this.searchByShippingId
      }
      if (this.searchByShippingId) {
        this.input.ShippingId = this.searchByShippingId
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'rvpinscanshipment/getpendingshipmentlist',
        data: this.input
      }).then(async res => {
        this.showPaginate = true
        this.isPendingShipmentLoading = false
        if (res.data.code === 204) {
          this.$alertify.error(res.data.message)
          return false
        }
        this.pendingShipmentList = res.data.data

        var total2 = res.data.total
        if (total2 < 10) {
          this.pagecount = 1
        } else {
          this.pagecount = Math.ceil(total2 / 10)
        }
      }).catch(err => {
        this.isPendingShipmentLoading = false
        console.log("Error Details", err);
        return false
      })
    },
    getShipmentbyShippingIdMdl() {
      this.isPendingShipmentLoadingMdl = true
      this.shipmentType = 'Reverse'
      this.input = {
        "HubId": this.hubid,
        "PageNo": this.searchByShippingIdMdl !== '' ? 1 : this.pageNumber,
        "ShipmentType": this.shipmentType,
      }
      if (this.searchByShippingIdMdl) {
        this.input.ShippingId = this.searchByShippingIdMdl;
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'rvpinscanshipment/getpendingshipmentlist',
        data: this.input
      }).then(res => {
        this.showPaginate = true
        this.isPendingShipmentLoadingMdl = false
        if (res.data.code === 204) {
          this.$alertify.error(res.data.message)
          return false
        }
        this.pendingShipmentListMdl = res.data.data
        this.total3 = res.data.total
        if (this.total3 < 10) {
          this.pageCount = 1
        } else {
          this.pageCount = Math.ceil(this.total3 / 10)
        }
      }).catch(err => {
        this.isPendingShipmentLoadingMdl = false
        console.log("Error Details", err);
        return false
      })
    },
    getShortageShipmentListMdl() {
      this.isShortageShipmentLoadingMdl = true
      this.reqPayload = {
        "HubID": this.hubid,
        "ShipmentStatus": "SAReturnPending",
        "PageNo": this.shortageShippingIdMdl ? 1 : this.pageNumShortageMdl,
        "PageSize": 10,
        "ShipmentType": 'Reverse'
      }
      if (this.outsourcingid) {
        this.reqPayload.OutSourcingMasterId = this.outsourcingid;
      }
      if (this.shortageShippingIdMdl) {
        this.reqPayload.ShippingID = this.shortageShippingIdMdl
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'rvpinscanshipment/getsareturnpendingagainsthub',
        data: this.reqPayload
      }).then(result => {
        this.isShortageShipmentLoadingMdl = false
        this.showShortagePaginateMdl = true
        // console.log("shortage modal list--",result);
        if (result.data.code === 200) {
          this.totalShortageShipMDl = result.data.result.TotalShipments
          this.shortageShipmentListMdl = result.data.result.Shipments

          if (this.totalShortageShipMDl < 10) {
            this.pageCountForShortageMdl = 1
          } else {
            this.pageCountForShortageMdl = Math.ceil(this.totalShortageShipMDl / 10)
          }
        } else if (result.data.code === 202) {
          this.$alertify.error("No Data Found");
          return false
        } else {
          this.$alertify.error(result.data.message);
          return false;
        }
      }).catch(error => {
        this.isShortageShipmentLoadingMdl = false;
        console.log("Error Details", error);
        return false
      })
    },
    refresh(tabtype) {
      if (tabtype === 'RVP') {
        if (this.searchByShippingId) {
          document.getElementById("clearSearchField").value = ''
          this.searchByShippingId = ''
        }
        this.getPendingShipmentListForPickupDone()
      } else if (tabtype === 'RVPModal') {
        if (this.searchByShippingIdMdl) {
          document.getElementById('clearSearchFieldMdl').value = '';
          this.searchByShippingIdMdl = ''
        }
        this.getShipmentbyShippingIdMdl()
      } else if (tabtype === 'SSMdl') {
        if (this.shortageShippingIdMdl) {
          document.getElementById('ShortageShippingMdl').value = '';
          this.shortageShippingIdMdl = '';
        }
        this.getShortageShipmentListMdl();
      } else {
        if (this.searchByShippingIdForShortage) {
          document.getElementById('clearShortageSearchField').value = ''
          this.searchByShippingIdForShortage = ''
        }
        this.getShortageShipmentList();
      }
    },
    checkPW() {
      if (this.physicalWeight) {
        var num = parseInt(this.physicalWeight)
        if (num >= 20) {
          this.showPWcheckBox = true
        } else {
          this.showPWcheckBox = false
          this.isConfirmPhyWt = false
        }
      }
    },

    reset() {
      this.$validator.reset()
      // if (document.getElementById('clearShipmentBarcode')) {
      //   document.getElementById('clearShipmentBarcode').value = ''
      // }
      document.getElementById('clearFlyerBarcode').value = ''
      document.getElementById("lengthid").value = ''
      document.getElementById("breadthid").value = ''
      document.getElementById("heightid").value = ''
      document.getElementById("physicalWeightId").value = ''
      this.flyerBarcode = ''
      // this.shipmentBarcode = ''
      this.physicalWeight = ''
      this.length = ''
      this.breadth = ''
      this.height = ''
      this.showPWcheckBox = false
      this.isConfirmPhyWt = false
      //this.openDimentionWeightTab = false
      this.onDimentionTabValidation = false
      //this.selectedWeight = {}
      this.isConfirmVolWt = false
      this.showVWcheckBox = false
      if (this.IsPrinterAvailable == true) {
        console.log("---Reset======");
        
        this.$refs.clearShipmentBarcode.focus();
      }
      else {
        this.$refs.clearFlyerBarcode.focus();
      }
    },
    resetAll() {
      this.selectedWeight = {},
        this.openDimentionWeightTab = false
      this.reset();
    },

    async uploadPODMultipleImage(RVPShipment) {
      this.GetUploadedImages(RVPShipment);
      this.RVPShipment = RVPShipment;
      if (this.RVPShipment != "") {
        this.checkUploadImg = 1
        this.checkTLQCProcessModal = true
      } else {
        this.checkUploadImg = 0
        this.$alertify.error("Please Enter RVP Shipment for scan");
      }
    },
    // openuploadMultipleImageModal() {
    //   this.uploadMultipleImageModal = true;
    // },
    closeuploadMultipleImageModal() {
      this.uploadMultipleImageModal = false;
      this.checkTLQCProcessModal = true;
    },
    // ClearuploadImageFile() {
    //   this.file = '';
    //   this.formData11 = '';
    //   this.validated = true
    //   this.uploadImage1 = {};
    //   this.QCSRValues = []
    //   this.Answer = []
    // },

    //Upload multiple files
    async handleFileUpload(event) {
      this.isLoadingupload = true;
      try {
        if (this.RVPShipment) {
          let uploadFile = event.target.files;
          this.UploadFilArr = [];

          this.podimagearray = []
          if (uploadFile.length > 4) {
            this.$alertify.error("Cannot Upload more than 4 images .");
            this.isLoadingupload = false;
            return false;
          } else if (this.UploadedImgCount == 4) {
            this.$alertify.error("Cannot Upload more than 4 images .");
            this.isLoadingupload = false;
          } else if (this.UploadedImgCount == 3 && uploadFile.length > 1) {
            this.$alertify.error("Please select only one image.");
            this.isLoadingupload = false;
          } else if (this.UploadedImgCount == 2 && uploadFile.length > 2) {
            this.$alertify.error("Please select only two images.");
            this.isLoadingupload = false;
          } else if (this.UploadedImgCount == 1 && uploadFile.length > 3) {
            this.$alertify.error("Please select only three images.");
            this.isLoadingupload = false;
          } else {
            let PromisSuccess = []
            for (var key = 0; key < uploadFile.length; key++) {
              let formData = new FormData();

              if (key >= 0) {
                let sanitizename;
                sanitizename = this.sanitizeFileName(key, uploadFile[key].name);
                const myRenamedFile = new File([uploadFile[key]], sanitizename, { type: uploadFile[key].type });
                this.UploadFilArr.push(myRenamedFile);
                if (this.UploadFilArr[key].type != "image/jpeg" && this.UploadFilArr[key].type != "image/jpg" && this.UploadFilArr[key].type != "image/png") {
                  this.$alertify.error("Please upload only valid file format(.jpeg, .png, .jpg)");
                  this.isLoadingupload = false;
                  this.closeuploadMultipleImageModal()
                }
              }
              if (this.UploadFilArr[key].size > (1024 * 1024 * 5)) {
                this.$alertify.error(`${this.UploadFilArr[key].name} size is greater than 5MB`, "", "error");
                this.isLoadingupload = false;
                this.closeuploadMultipleImageModal()
              }
              else {
                if (this.isSKUDAta.IsSku == 0) {
                  formData.append("ShippingID", this.RVPShipment.trim());
                  formData.append("file", this.UploadFilArr[key]);
                }
                else if (this.isSKUDAta.IsSku == 1) {
                  formData.append("ShippingID", this.RVPShipment.trim());
                  if (this.currentTabTitle) formData.append("ProductID", this.currentTabTitle.trim());
                  formData.append("file", this.UploadFilArr[key]);
                }
                PromisSuccess.push(this.UploadImagesfun(formData));
              }
            }
            Promise.all(PromisSuccess).then(async result => {
              if (result.success = true) {
                this.$alertify.success("Images Uploaded Successfully");
              } else {
                this.$alertify.error("Images could not be uploaded.");
                this.isLoadingupload = false;
              }
              this.GetUploadedImages();
              this.closeuploadMultipleImageModal()
            })
          }
        } else {
          this.$alertify.error("Not getting Shipment id.");
          this.isLoadingupload = false;
          this.closeuploadMultipleImageModal()
        }
      } catch (error) {
        console.log("Error", error);
        this.isLoadingupload = false
      }
    },
    UploadImagesfun(formData) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'DayEndClosure/uploadS3Image',
          data: formData,
        })
          .then(result => {
            if (result.status == 200) {
              resolve({ success: true });

            } else {
              resolve({ success: false });
            }
          }, error => {
            resolve({ success: false });
          })
      });
    },
    //Get Uploaded iamges from s3
    GetUploadedImages() {
      this.isLoadingupload = true;
      this.UploadedImageArr = [];
      this.UploadedImgCount = 0;
      let input = {}
      if (this.isSKUDAta.IsSku == 0) {
        input.ShippingID = this.RVPShipment.trim()
      }
      else if (this.isSKUDAta.IsSku == 1) {
        if (this.currentTabTitle) input.ProductID = this.currentTabTitle.trim();
        input.ShippingID = this.RVPShipment.trim()
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'DayEndClosure/GetUploadedQCCheckS3Images',
        data: input
      })
        .then(result => {
          if (result.data.code == 200) {
            this.UploadedImageArr = result.data.data;
            this.UploadedImgCount = this.UploadedImageArr.length
            this.isLoadingupload = false;
          }
          else {
            this.UploadedImgCount = this.UploadedImageArr.length
            this.$alertify.error(result.data.message)
            this.isLoadingupload = false;
          }
        })
    },
    RemoveImage(item) {
      let splitURL = item.ImageUrl.split("?");
      this.DeleteURL = splitURL[0]
      this.input = {
        "ImageUrl": this.DeleteURL,
      }
      // console.log("DeleteURL",this.DeleteURL);
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'DayEndClosure/DeleteQCCheckS3Image',
        'data': this.input,
      })
        .then(result => {
          if (result.data.code == 200) {
            this.$alertify.success('File Removed Successfully');
            item.ImageUrl = '';
            this.file = '';
            this.GetUploadedImages();
          }
          else {
            this.$alertify.error(result.data.message)
          }
        })
    },

    handleShipmentKeyDown(event) {
      clearTimeout(this.timeout);
      if (event.key === 'Enter' || event.key === 'Tab' || event.keyCode === 13 || event.keyCode === 9) {
        this.$refs.clearFlyerBarcode.focus(); // Focus on the flyer input box
        return false;
      } else {
        const effectiveDelay = this.ttl != null && this.ttl != undefined ? this.ttl : 200;
        return this.timeout = setTimeout(() => {
          // this.shipmentBarcode = '';
          this.$alertify.error("Please Scan Shipment barcode.");
        }, effectiveDelay);
      }
    }
    ,
    async handleFlyerKeyDown(event) {
      clearTimeout(this.timeout);
      if (event.key === 'Enter' || event.key === 'Tab' || event.keyCode === 13 || event.keyCode === 9) {
        await this.checkTLQCStatus(this.shipmentBarcode, this.flyerBarcode)
        return false;
      } else {
        const effectiveDelay = this.ttl != null && this.ttl != undefined ? this.ttl : 200;
        return this.timeout = setTimeout(() => {
          console.log('Manual entry detected. Clearing input...');
          this.flyerBarcode = '';
          this.$alertify.error("Please Scan Flyer barcode.")
          return false;
        }, effectiveDelay);
      }
    },

    // updateEODBatchStatus(DeliveryUserID,HubID,LastModifiedBy){
    //   this.input = {
    //     "DeliveryUserID": DeliveryUserID,
    //     "HubID": HubID,
    //     "LastModifiedBy":LastModifiedBy
    //   }
    //   axios({
    //     method: 'POST',
    //     url: apiUrl.api_url + 'DayEndClosure/updateEODBatchStatus',
    //     data: this.input
    //   })
    //   .then(respons => {
    //     console.log('response of updateEODBatchStatus',respons);
    //   })
    // }

    sanitizeFileName(key, fileNameWithExt) {
      var fileExt = fileNameWithExt.split('.').pop();
      // let dotLastIndex = fileNameWithExt.lastIndexOf('.');
      // let finalNameWithoutExtension = fileNameWithExt.substring(0, dotLastIndex);
      // let sanitizedfileName = finalNameWithoutExtension.replace(/[^a-zA-Z0-9']/g, '').replace(' ', '');
      let sanitizenametemp = key + '.' + fileExt;
      return sanitizenametemp;
    },
    reprintStricker() {
      /* Checking Fresh Print Role */
      let allowedReprintRole = this.shipResponseData.allowedReprintRole.map(item => item.toLowerCase());
      if (allowedReprintRole.includes(this.userrole.toLowerCase())) {
        this.isShowReprintPopUp = true;
      } else {
        this.isShowReprintPopUpReprint = true;
        this.$alertify.error("You are not authorized to print stickers for this shipment.");
        this.closeModelReprint();
      }
    },
    closeModelReprint() {
      this.isShowReprintPopUp = false;
    },

    reprintRequest() {
      /* Calling Reprint */
      this.checkUserAuthorizedOrNot();
    },

    /* Printing Start */
    /* Check User Authorised or not Authorised */
    checkUserAuthorizedOrNot() {
      /* Checking Fresh Print Role */
      let allowedReprintRole = this.shipResponseData.allowedReprintRole.map(item => item.toLowerCase());
      if (allowedReprintRole.includes(this.userrole.toLowerCase())) {
        if (this.shipResponseData.paperSheetDetails) {
            this.$alertify.error("Sticker printing is not possible at this facility due to the absence of a printer");
          /* DTO paper Sheet */
          // let paperSheet_payload = {
          //   "hubid": parseInt(this.hubid),
          //   "FlyerBarcodeNumber": this.propsParam.shipmentDetails.ShippingId.trim().toUpperCase(),
          //   "IsShippingId": (this.propsParam.shipmentDetails.ShippingId && this.propsParam.shipmentDetails.ShippingId.trim().toUpperCase().startsWith('RVP') ? false : true),
          // };
          // this.isDtoPaperSheetOnOrOff = true;
          // this.dtoPaperSheet(paperSheet_payload);

        } else {
          /* RTO/DTO/FWD Stricker Printing */
          if (this.shipResponseData.shipmentType && ['rto', 'dto'].includes(this.shipResponseData.shipmentType.toLowerCase())) {
            this.rtoDtoStrickerPrint();
          } else {
            this.fwdStrickerPrint();
          }
        }
      } else {

        this.isShowReprintPopUpReprint = true;
        this.$alertify.error("You are not authorized to print stickers for this shipment.");
        this.closeModelReprint();
      }
    },

    /* Generate DTO Paper Sheet */
    dtoPaperSheet(paperSheet_payload) {
      this.isLoading = true;

      fetchShipmentLabelData(paperSheet_payload, (result) => {
        try {
          /* Update Shipment Status */
          let RequestForNewPrint = {
            "hubid": this.hubid,
            "requestedby": this.userid,
            "requestsource": 'lm',
            "shippingid": this.propsParam.shipmentDetails.ShippingId.trim().toUpperCase(),
            "shipmenttype": this.shipResponseData.shipmentType,
            "centertype": this.shipResponseData.centerType,
            "istlqceligible": this.shipResponseData.isTlqcShipment,
            "istlqcdone": this.shipResponseData.hasTlqcProcessCompleted,
            "userrole": this.userrole,
            "isDtoPaperSheetOnOrOff" : this.isDtoPaperSheetOnOrOff,
          }
          if (result.data.type == 'application/pdf') {//result.data.type == 'application/pdf'
            const downloadUrl = window.URL.createObjectURL(new Blob([result.data], { type: 'application/pdf' }));

            let message = {
              title: '',
              body: `<p>Pdf is generated, Would you like to Download.!</p>`,
            };

            this.$dialog.alert(message, {
              html: true,
              animation: 'bounce',
              backdropClose: false,
              loader: true,
              loaderMsg: 'Loading PDF, please wait...'
            }).then(dialog => {

              // Create a temporary anchor element
              const link = document.createElement('a');

              // Set the download attribute to specify the filename
              link.href = downloadUrl;
              link.download = 'dtopapersheet.pdf';  // You can change 'filename.pdf' to whatever name you want

              // Append the link to the document (it can be any parent element, but we can use document.body)
              document.body.appendChild(link);

              // Trigger a click event on the link to start the download
              link.click();

              // Remove the link after the download has been triggered (cleaning up)
              document.body.removeChild(link);

              // Optionally, revoke the object URL to free up resources
              window.URL.revokeObjectURL(downloadUrl);
              // window.open(downloadUrl);

              dialog.close();

              RequestForNewPrint.action = "printdone";
              updateShipmentStatusForOnePager(RequestForNewPrint, (result) => {
                try {
                  if (result.data.code == 200) {
                    this.$alertify.success(result.data.message);
                    this.closeModelReprint();
                  } else {
                    this.$alertify.error(result.data.message);
                    this.closeModelReprint();
                  }
                } catch (error) {
                  console.log('result------', error.message);
                }
              })
            }).catch(() => {
              this.isLoading = false;
            });
          } else {
            this.$alertify.error("Invalid Shipment");
          }
        } catch (e) {
          console.log('result------', e.message);
        }
      })
    },

    /* Fwd Stricker Printing */
    fwdStrickerPrint() {
      this.prnData = `^XA
                                ^SZ2^JMA
                                ^MCY^PMN
                                ^PW812
                                ~SD12^MD0^MTD
                                ~JSN
                                ~SD25^MD0
                                ^JZY
                                ^LH0,0^LRN
                                ^XZ
                                ^XA
                                ^FO3,66
                                ^GB803,0,3^FS
                                ^FO2,135
                                ^GB805,0,3^FS
                                ^FO3,241
                                ^GB803,0,3^FS
                                ^FO3,343
                                ^GB803,0,3^FS
                                ^FO3,444
                                ^GB803,0,3^FS
                                ^FO3,525
                                ^GB803,0,3^FS
                                ^FO400,68
                                ^GB0,66,3^FS
                                ^FO180,242
                                ^GB0,205,3^FS
                                ^FO135,448
                                ^GB0,77,3^FS
                                ^FO393,448
                                ^GB0,77,3^FS
                                ^FO504,448
                                ^GB0,77,3^FS
                                ^FO215,525
                                ^GB0,60,3^FS
                                ^FO361,525
                                ^GB0,60,3^FS
                                ^FT20,35
                                ^CI0
                                ^A0N,38,30^FDXPRESSBEES^FS
                                ^FT115,57
                                ^A0N,17,23^FDDelivering Happiness^FS
                                ^FT712,54
                                ^A0N,45,30^FDFWD^FS
                                ^FT21,118
                                ^A0N,42,30^FDDelivery Type : ${this.shipResponseData.prnDetails.OrderType}^FS
                                ^FT450,118
                                ^A0N,42,30^FD${this.shipResponseData.prnDetails.ProcessCode}^FS
                                ^FO50,149
                                ^BY2^BCN,53,N,N^FD>:${this.shipResponseData.prnDetails.ShippingID}^FS
                                ^FT50,229
                                ^A0N,25,27^FD${this.shipResponseData.prnDetails.ShippingID}^FS
                                ^FT20,283
                                ^A0N,30,20^FDCust Name :-^FS
                                ^FT20,327
                                ^A0N,30,20^FDCust Address :-^FS
                                ^FT190,275
                                ^A0N,20,25^FD${this.shipResponseData.prnDetails.CustomerName}^FS
                                ^FT190,310
                                ^A0N,20,20^FD${this.shipResponseData.prnDetails.CustomerAddress1}^FS
                                ^FT190,335
                                ^A0N,20,20^FD${this.shipResponseData.prnDetails.CustomerAddress2}^FS
                                ^FT20,385
                                ^A0N,30,20^FDRTO Name :-^FS
                                ^FT20,430
                                ^A0N,30,20^FDRTO Address :-^FS
                                ^FT190,377
                                ^A0N,20,25^FD${this.shipResponseData.prnDetails.destiRtoHubName}^FS
                                ^FT190,413
                                ^A0N,20,20^FD${this.shipResponseData.prnDetails.RTOAddress1}^FS
                                ^FT190,438
                                ^A0N,20,20^FD${this.shipResponseData.prnDetails.RTOAddress2}^FS
                                ^FT20,480
                                ^A0N,30,20^FDDestination^FS
                                ^FT20,516
                                ^A0N,30,20^FDHub :-^FS
                                ^FT145,510
                                ^A0N,34,30^FD${this.shipResponseData.prnDetails.destinationhubname}^FS
                                ^FT410,481
                                ^A0N,30,20^FDClient^FS
                                ^FT410,511
                                ^A0N,30,20^FDName :-^FS
                                ^FT517,511
                                ^A0N,34,30^FD${this.shipResponseData.prnDetails.clientName}^FS
                                ^FT20,565
                                ^A0N,30,20^FDDelivery Pincode :-^FS
                                ^FT228,565
                                ^A0N,28,38^FD${this.shipResponseData.prnDetails.CustomerPinCode}^FS
                                ^PQ1,0,1,Y
                                ^XZ`;


      if (this.prnData) {
        this.printstickernew();
      }
    },

    /* RTO/DTO/FWD Stricker Printing */
    rtoDtoStrickerPrint() {
      /* RTO DTO Printing Format */
      if (this.shipResponseData.prnDetails.shipmenttype && this.shipResponseData.prnDetails.shipmenttype.toLowerCase() == 'dto') {
        if (this.isSelectPrinter == '1') {
          console.log("---DTO New---");

          this.prnData = `^XA
                    ^SZ2^JMA
                    ^MCY^PMN
                    ^PW812
                    ~JSN
                    ^JZY
                    ^LH0,0^LRN
                    ^XZ
                    ^XA
                    ^FO3,73
                    ^GB803,0,3^FS
                    ^FO3,134
                    ^GB803,0,3^FS
                    ^FO3,240
                    ^GB803,0,3^FS
                    ^FO3,328
                    ^GB803,0,3^FS
                    ^FO3,423
                    ^GB803,0,3^FS
                    ^FO3,516
                    ^GB803,0,3^FS
                    ^FO332,75
                    ^GB0,61,3^FS
                    ^FO482,77
                    ^GB0,250,3^FS
                    ^FO560,77
                    ^GB0,250,3^FS
                    ^FO710,76
                    ^GB0,61,3^FS
                    ^FO149,241
                    ^GB0,350,3^FS
                    ^FO393,425
                    ^GB0,91,3^FS
                    ^FO504,426
                    ^GB0,91,3^FS
                    ^FO301,520
                    ^GB0,65,3^FS
                    ^FT33,43
                    ^CI0
                    ^A0N,38,30^FDXPRESSBEES^FS
                    ^FT115,65
                    ^A0N,17,23^FDDelivering Happiness^FS
                    ^FT401,51
                    ^A0N,39,26^FD${this.shipResponseData.prnDetails.dummyRouteCodeData}^FS
                    ^FT730,48
                    ^A0N,39,26^FD${this.shipResponseData.prnDetails.shipmenttype}^FS
                    ^FT31,114
                    ^A0N,42,30^FDRemarks :-^FS
                    ^FT176,116
                    ^A0N,42,30^FD${this.shipResponseData.prnDetails.remarks}^FS
                    ^FT341,114
                    ^A0N,42,30^FD${this.shipResponseData.prnDetails.rtogcregion + this.shipResponseData.prnDetails.rtogctype}^FS
                    ^FT510,114
                    ^A0N,42,30^FD${this.shipResponseData.prnDetails.destination}^FS
                    ^FT587,114
                    ^A0N,42,30^FD${this.shipResponseData.prnDetails.routenumber}^FS
                    ^FT730,114
                    ^A0N,42,30^FD${this.shipResponseData.prnDetails.routecode}^FS
                    ^FT489,170
                    ^A0N,31,16^FDFlier Code^FS
                    ^FT490,211
                    ^A0N,23,28^FD${this.shipResponseData.prnDetails.truncfliercode}^FS
                    ^FT571,170
                    ^A0N,28,19^FDLast WH Handover Date^FS
                    ^FT570,211
                    ^A0N,23,28^FD${this.shipResponseData.prnDetails.lastwhhandoverdateformated}^FS
                    ^FO18,148
                    ^BY2^BCN,50,N,N^FD>:${this.shipResponseData.prnDetails.shippingid}^FS
                    ^FT140,225
                    ^A0N,25,27^FD${this.shipResponseData.prnDetails.shippingid}^FS
                    ^FT489,295
                    ^A0N,34,18^FDEway Bill^FS
                    ^FT589,296
                    ^A0N,34,28^FD${this.shipResponseData.prnDetails.ewaybill}^FS
                    ^FT22,277
                    ^A0N,34,23^FDVendor^FS
                    ^FT22,311
                    ^A0N,34,23^FDName :-^FS
                    ^FT157,271
                    ^A0N,25,20^FD${this.shipResponseData.prnDetails.vendorname1}^FS
                    ^FT157,297
                    ^A0N,25,20^FD${this.shipResponseData.prnDetails.vendorname2}^FS
                    ^FT157,323
                    ^A0N,25,20^FD${this.shipResponseData.prnDetails.vendorname3}^FS
                    ^FT23,370
                    ^A0N,34,23^FDVendor^FS
                    ^FT23,405
                    ^A0N,34,23^FDAddress :-^FS
                    ^FT158,355
                    ^A0N,17,25^FD${this.shipResponseData.prnDetails.vendoraddress1}^FS
                    ^FT158,375
                    ^A0N,17,25^FD${this.shipResponseData.prnDetails.vendoraddress2}^FS
                    ^FT158,395
                    ^A0N,17,25^FD${this.shipResponseData.prnDetails.vendoraddress3}^FS
                    ^FT158,415
                    ^A0N,17,25^FD${this.shipResponseData.prnDetails.vendoraddress4}^FS
                    ^FT23,465
                    ^A0N,34,23^FDDestination^FS
                    ^FT23,500
                    ^A0N,34,23^FDHub :-^FS
                    ^FT160,455
                    ^A0N,28,25^FD${this.shipResponseData.prnDetails.destinationhub1}^FS
                    ^FT160,480
                    ^A0N,28,25^FD${this.shipResponseData.prnDetails.destinationhub2}^FS
                    ^FT160,505
                    ^A0N,28,25^FD${this.shipResponseData.prnDetails.destinationhub3}^FS
                    ^FT408,465
                    ^A0N,34,22^FDClient^FS
                    ^FT408,498
                    ^A0N,34,22^FDName :-^FS
                    ^FT513,450
                    ^A0N,25,25^FD${this.shipResponseData.prnDetails.clientname1}^FS
                    ^FT513,476
                    ^A0N,25,25^FD${this.shipResponseData.prnDetails.clientname2}^FS
                    ^FT513,500
                    ^A0N,25,25^FD${this.shipResponseData.prnDetails.clientname3}^FS
                    ^FT15,545
                    ^A0N,25,25^FDDelivery^FS
                    ^FT15,570
                    ^A0N,25,25^FDPincode :-^FS
                    ^FT170,554
                    ^A0N,28,38^FD${this.shipResponseData.prnDetails.deliverypincode}^FS
                    ^FT320,548
                    ^A0N,23,16^FDPO ID /^FS
                    ^FT320,570
                    ^A0N,23,16^FDOrderId :-^FS
                    ^FO400,530
                    ^BCN,27,N,N^FD>:${this.shipResponseData.prnDetails.poid}^FS
                    ^FT472,580
                    ^A0N,23,23^FD${this.shipResponseData.prnDetails.poid}^FS
                    ^PQ1,0,1,Y
                    ^XZ`;

        } else {
          console.log("---DTO Old---");
          this.prnData = 'n\n' + 'M0751\n' + 'KW0400\n' + 'O0220\n' + 'V0\n' + 'f303\n' + 'D\n' + 'L\n' + 'D11\n' + 'A2\n' + '1X1100002690000L400001\n' + '1921A0602850007XPRESSBEES\n' +
            '1911A1402740338' + this.shipResponseData.prnDetails.shipmenttype + '\n' +
            '1X1100002420000L400001\n' +
            '1911A1202470162' + this.shipResponseData.prnDetails.rtogcregion + '/' + this.shipResponseData.prnDetails.rtogctype + '\n' +
            '1911A1202470253' + this.shipResponseData.prnDetails.destination + '\n' +
            '1911A1202470308' + this.shipResponseData.prnDetails.routenumber + '\n' +
            '1911A1202470347' + this.shipResponseData.prnDetails.routecode + '\n' +
            '1911A0602740082Delivering Happiness\n' +
            '1X1100002420144L001027\n' + '1X1100002420244L001027\n' + '1X1100002410289L001028\n' + '1X1100002420344L001027\n' +
            '1X1100001670000L400001\n' + '1X1100001290000L400001\n' + '1X1100000810000L400001\n' + '1X1100000420000L400001\n' + '1911A0801480007Vendor\n' +
            '1911A0801360007Name :- \n' + '1911A0801040007Vendor\n' + '1911A0800930007Address :-\n' + '1911A0800590007Destination\n' + '1911A0800470007Hub :-\n' +
            '1911A0800610197Client\n' + '1911A0800490197Name :-\n' + '1911A0602190298Last WH Handover Date\n' +
            '1911A1201840303' + this.shipResponseData.prnDetails.lastwhhandoverdateformated + '\n' +
            '1X1100001670289L001076\n' +
            '1911A0600660253' + this.shipResponseData.prnDetails.clientname1 + '\n' +
            '1911A0600570253' + this.shipResponseData.prnDetails.clientname2 + '\n' +
            '1911A0600480253' + this.shipResponseData.prnDetails.clientname3 + '\n' +
            '1911A0601140074' + this.shipResponseData.prnDetails.vendoraddress1 + '\n' +
            '1911A0601050074' + this.shipResponseData.prnDetails.vendoraddress2 + '\n' +
            '1911A0600960074' + this.shipResponseData.prnDetails.vendoraddress3 + '\n' +
            '1911A0600870074' + this.shipResponseData.prnDetails.vendoraddress4 + '\n' +
            '1911A0601530073' + this.shipResponseData.prnDetails.vendorname1 + '\n' +
            '1911A0601440073' + this.shipResponseData.prnDetails.vendorname2 + '\n' +
            '1911A0601350073' + this.shipResponseData.prnDetails.vendorname3 + '\n' +
            '1911A0600660080' + this.shipResponseData.prnDetails.destinationhub1 + '\n' +
            '1911A0600570080' + this.shipResponseData.prnDetails.destinationhub2 + '\n' +
            '1911A0600480080' + this.shipResponseData.prnDetails.destinationhub3 + '\n' +
            '1911A0800180007Delivery Pincode :-\n' + '1X1100000010102L001041\n' +
            '1911A0802500007Remarks :- ' + this.shipResponseData.prnDetails.remarks + '\n' +
            '1X1100000430069L001125\n' + '1X1100000430193L001038\n' + '1X1100000420244L001039\n' + '1X1100003000000L400001\n' +
            '1911A1202740183' + this.shipResponseData.prnDetails.dummyRouteCodeData + '\n' +
            '1e6205201840010B' + this.shipResponseData.prnDetails.shippingid + '\n' +
            '1911A0801700066' + this.shipResponseData.prnDetails.shippingid + '\n' +
            '1X1100001680228L001075\n' + '1911A0602190240Flier Code\n' +
            '1911A1201840242' + this.shipResponseData.prnDetails.truncfliercode + '\n' +
            '1a3101800190210' + this.shipResponseData.prnDetails.poid + '\n' +
            '1911A0600070245' + this.shipResponseData.prnDetails.poid + '\n' +
            '1911A0600200107' + this.shipResponseData.prnDetails.deliverypincode + '\n' +
            '1X1100000010137L001042\n' + '1911A0600200145POID/ Order ID\n' +
            '1911A0801420308' + this.shipResponseData.prnDetails.ewaybill + '\n' +
            '1X1100001300300L001038\n' + '1911A0801420246E-way Bill\n' + '1X1100001300241L001038\n' +
            'Q0001\n' +
            'E\n';
        }
      }
      else if (this.IsRtoRestrict) {
        if (this.isSelectPrinter == '1') {
          console.log("---RTO New---");
          this.prnData = `^XA
                ^SZ2^JMA
                ^MCY^PMN
                ^PW812
                ~JSN
                ~SD25^MD0
                ^JZY
                ^LH0,0^LRN
                ^XZ
                ^XA
                ^FO3,73
                ^GB803,0,3^FS
                ^FO2,142
                ^GB805,0,3^FS
                ^FO3,248
                ^GB803,0,3^FS
                ^FO3,336
                ^GB803,0,3^FS
                ^FO8,432
                ^GB803,0,3^FS
                ^FO8,524
                ^GB803,0,3^FS
                ^FO309,75
                ^GB0,66,3^FS
                ^FO466,75
                ^GB0,66,3^FS
                ^FO560,75
                ^GB0,66,3^FS
                ^FO710,75
                ^GB0,66,3^FS
                ^FO560,146
                ^GB0,101,3^FS
                ^FO149,249
                ^GB0,91,3^FS
                ^FO149,340
                ^GB0,91,3^FS
                ^FO148,434
                ^GB0,91,3^FS
                ^FO393,435
                ^GB0,91,3^FS
                ^FO504,434
                ^GB0,91,3^FS
                ^FO215,524
                ^GB0,60,3^FS
                ^FO361,524
                ^GB0,60,3^FS
                ^FO504,524
                ^GB0,60,3^FS
                ^FT33,43
                ^CI0
                ^A0N,38,30^FDXPRESSBEES^FS
                ^FT115,65
                ^A0N,17,23^FDDelivering Happiness^FS
                ^FT382,63
                ^A0N,45,30^FD${this.shipResponseData.prnDetails.dummyRouteCodeData}^FS
                ^FT712,54
                ^A0N,45,30^FD${this.shipResponseData.prnDetails.shipmenttype}^FS
                ^FT21,118
                ^A0N,42,30^FDDelivery Type : ${this.shipResponseData.prnDetails.deliverytype}^FS
                ^FT318,118
                ^A0N,42,30^FD${this.shipResponseData.prnDetails.rtogcregion + this.shipResponseData.prnDetails.rtogctype}^FS
                ^FT487,118
                ^A0N,42,30^FD${this.shipResponseData.prnDetails.destination}^FS
                ^FT592,118
                ^A0N,42,30^FD${this.shipResponseData.prnDetails.routenumber}^FS
                ^FT730,118
                ^A0N,42,30^FD${this.shipResponseData.prnDetails.routecode}^FS
                ^FO50,149
                ^BY2^BCN,53,N,N^FD>:${this.shipResponseData.prnDetails.shippingid}^FS
                ^FT50,229
                ^A0N,25,27^FD${this.shipResponseData.prnDetails.shippingid}^FS
                ^FT571,178
                ^A0N,28,20^FDLast WH Handover Date^FS
                ^FT571,224
                ^A0N,30,30^FD${this.shipResponseData.prnDetails.lastwhhandoverdateformated}^FS
                ^FT20,285
                ^A0N,34,23^FDVendor^FS
                ^FT20,320
                ^A0N,34,23^FDName :-^FS
                ^FT160,280
                ^A0N,20,20^FD${this.shipResponseData.prnDetails.vendorname1}^FS
                ^FT160,317
                ^A0N,20,20^FD${this.shipResponseData.prnDetails.vendorname2}^FS
                ^FT20,378
                ^A0N,34,23^FDVendor^FS
                ^FT20,413
                ^A0N,34,23^FDAddress :-^FS
                ^FT158,356
                ^A0N,17,25^FD${this.shipResponseData.prnDetails.vendoraddress1}^FS
                ^FT158,377
                ^A0N,17,25^FD${this.shipResponseData.prnDetails.vendoraddress2}^FS
                ^FT158,398
                ^A0N,17,25^FD${this.shipResponseData.prnDetails.vendoraddress3}^FS
                ^FT158,419
                ^A0N,17,25^FD${this.shipResponseData.prnDetails.vendoraddress4}^FS
                ^FT20,473
                ^A0N,34,23^FDDestination^FS
                ^FT20,508
                ^A0N,34,23^FDHub :-^FS
                ^FT158,461
                ^A0N,28,25^FD${this.shipResponseData.prnDetails.destinationhub1}^FS
                ^FT158,487
                ^A0N,28,25^FD${this.shipResponseData.prnDetails.destinationhub2}^FS
                ^FT158,514
                ^A0N,28,25^FD${this.shipResponseData.prnDetails.destinationhub3}^FS
                ^FT410,473
                ^A0N,34,23^FDClient^FS
                ^FT410,503
                ^A0N,34,23^FDName :-^FS
                ^FT517,461
                ^A0N,25,25^FD${this.shipResponseData.prnDetails.clientname1}^FS
                ^FT517,491
                ^A0N,25,25^FD${this.shipResponseData.prnDetails.clientname2}^FS
                ^FT517,521
                ^A0N,25,25^FD${this.shipResponseData.prnDetails.clientname3}^FS
                ^FT20,566
                ^A0N,34,23^FDDelivery Pincode :-^FS
                ^FT228,564
                ^A0N,28,38^FD${this.shipResponseData.prnDetails.deliverypincode}^FS
                ^FT380,564
                ^A0N,28,19^FDE-WAY Bill :-^FS
                ^FT549,562
                ^A0N,28,38^FD${this.shipResponseData.prnDetails.ewaybill}^FS
                ^PQ1,0,1,Y
                ^XZ`;

        } else {
          console.log("---RTO Old---");
          this.prnData = 'n\n' + 'M0751\n' + 'KW0400\n' + 'O0220\n' + 'V0\n' + 'f303\n' + 'D\n' + 'L\n' + 'D11\n' + 'A2\n' + '1X1100002690000L400001\n' + '1921A0602850007XPRESSBEES\n' +
            '1911A1402740337' + this.shipResponseData.prnDetails.shipmenttype + '\n' +
            '1X1100002420000L400001\n' +
            '1911A1202470162' + this.shipResponseData.prnDetails.rtogcregion + '/' + this.shipResponseData.prnDetails.rtogctype + '\n' +
            '1911A1202470253' + this.shipResponseData.prnDetails.destination + '\n' +
            '1911A1202470308' + this.shipResponseData.prnDetails.routenumber + '\n' +
            '1911A1202470353' + this.shipResponseData.prnDetails.routecode + '\n' +
            '1911A0602740082Delivering Happiness\n' +
            '1X1100002420144L001027\n' + '1X1100002420244L001027\n' + '1X1100002420289L001027\n' + '1X1100002420344L001027\n' + '1X1100001670000L400001\n' + '1X1100001290000L400001\n' +
            '1X1100000810000L400001\n' + '1X1100000420000L400001\n' +
            '1e6205201840010B' + this.shipResponseData.prnDetails.shippingid + '\n' +
            '1911A1001670042' + this.shipResponseData.prnDetails.shippingid + '\n' +
            '1911A0801480007Vendor\n' + '1911A0801360007Name :- \n' + '1911A0801040007Vendor\n' + '1911A0800930007Address :-\n' + '1911A0800590007Destination\n' +
            '1911A0800470007Hub :-\n' + '1911A0800610197Client\n' + '1911A0800490197Name :-\n' + '1911A0602190290Last WH Handover Date\n' +
            '1911A1201840289' + this.shipResponseData.prnDetails.lastwhhandoverdateformated + '\n' +
            '1X1100001680265L001075\n' +
            '1911A0600660253' + this.shipResponseData.prnDetails.clientname1 + '\n' +
            '1911A0600570253' + this.shipResponseData.prnDetails.clientname2 + '\n' +
            '1911A0600480253' + this.shipResponseData.prnDetails.clientname3 + '\n' +
            '1911A0601140080' + this.shipResponseData.prnDetails.vendoraddress1 + '\n' +
            '1911A0601050080' + this.shipResponseData.prnDetails.vendoraddress2 + '\n' +
            '1911A0600960080' + this.shipResponseData.prnDetails.vendoraddress3 + '\n' +
            '1911A0600870080' + this.shipResponseData.prnDetails.vendoraddress4 + '\n' +
            '1911A0601480078' + this.shipResponseData.prnDetails.vendorname1 + '\n' +
            '1911A0601390078' + this.shipResponseData.prnDetails.vendorname2 + '\n' +
            '1911A0600660080' + this.shipResponseData.prnDetails.destinationhub1 + '\n' +
            '1911A0600570080' + this.shipResponseData.prnDetails.destinationhub2 + '\n' +
            '1911A0600480080' + this.shipResponseData.prnDetails.destinationhub3 + '\n' +
            '1911A0800170007Delivery Pincode :-\n' + '1X1100000010129L001041\n' +
            '1911A0800170133' + this.shipResponseData.prnDetails.deliverypincode + '\n' +
            '1X1100000420194L001039\n' + '1X1100000010194L001042\n' + '1911A0800160197E-way Bill\n' + '1X1100000010274L001042\n' +
            '1911A0800170285' + this.shipResponseData.prnDetails.ewaybill + '\n' +
            '1911A0802500007Delivery Type :- ' + this.shipResponseData.prnDetails.deliverytype + '\n' +
            '1X1100000430069L001125\n' + '1X1100000420244L001039\n' + '1X1100003000000L400001\n' +
            '1911A1202740183' + this.shipResponseData.prnDetails.dummyRouteCodeData + '\n' + 'Q0001\n' + 'E\n';
        }
      }
      else {
        this.$alertify.error("Shipment not eligible for Printing");
        this.isLoading = false;
      }
      //  console.log("prn"+JSON.stringify(this.prnData));
      if (this.prnData) {
        this.printstickernew();
      }
      /* RTO DTO Printing Format End */

    },

    /* Stricker Printing RTO/DTO/FWD */
    printstickernew() {
      this.isLoading = true;
      let RequestForNewPrint = {
        "hubid": this.hubid,
        "requestedby": this.userid,
        "requestsource": 'lm',
        "shippingid": this.propsParam.shipmentDetails.ShippingId.trim().toUpperCase(),
        "shipmenttype": this.shipResponseData.shipmentType,
        "centertype": this.shipResponseData.centerType,
        "istlqceligible": this.shipResponseData.isTlqcShipment,
        "istlqcdone": this.shipResponseData.hasTlqcProcessCompleted,
        "userrole": this.userrole,
        "action": 'printfailed',
        "isDtoPaperSheetOnOrOff" : this.isDtoPaperSheetOnOrOff,
      };

      /* For Printing Log Request Paylaod */
      let flierRegex = new RegExp("^RVP");
      this.loginput = {
        CurrentHubID: this.hubId,
        PrintedBy: this.username,
        PrintedDate: moment().format('YYYY-MM-DD HH:mm:ss'),
        Status: 'printFailed',
        ShipmentType: this.shipResponseData.shipmentType,
        CreatorsRole: this.userrole
      }
      if (['dto'].includes(this.shipResponseData.shipmentType.toLowerCase())) {
        this.loginput.FlyerCode = flierRegex.test(this.shipmentBarcode.trim().toUpperCase()) ? this.shipmentBarcode.trim() : this.shipResponseData.Flyerbarcode ? this.shipResponseData.Flyerbarcode : '',
          this.loginput.FlyerShippingId = this.shipResponseData.prnDetails.shippingid ? this.shipResponseData.prnDetails.shippingid : this.shipmentBarcode.trim();
      } else {
        this.loginput.FlyerCode = '';
        this.loginput.FlyerShippingId = this.shipResponseData.prnDetails.ShippingID ? this.shipResponseData.prnDetails.ShippingID : this.shipmentBarcode.trim();
      }

      // Delivery
      /* Printing Payload */
      this.input = {
        prnData: this.prnData,
        bagNumber: moment().format('DD-MM-YYYY')
      }

      axios({
        method: "POST",
        url: "http://localhost:4500/printer/printbagsticker",
        data: this.input,
      })
        .then(result => {
          console.log("result", result);
          if (result.data.ResultCode == 100) {
            this.loginput.Status = 'printDone';
            this.addStickerLog(this.loginput);
            this.$alertify.success(result.data.ReturnMessage);
            RequestForNewPrint.action = "tlqcdone";
            updateShipmentStatusForOnePager(RequestForNewPrint, (result) => {
              try {
                /* reset All Fields */
                // this.reset();
                this.isLoading = false;
                if (result.data.code == 200) {
                  this.$alertify.success(result.data.message);
                  this.closeModelReprint();
                } else {
                  this.$alertify.error(result.data.message);
                  this.closeModelReprint();
                }
              } catch (error) {
                console.log('result------', error.message);
              }
            })
          } else {
            this.addStickerLog(this.loginput);
            this.$alertify.error(result.data.ReturnMessage);
          }
        }, error => {
          console.log("Errro block", error);
          var code = error.response == undefined ? code = 0 : error.response.status;
          if (code == 500) {
            this.$alertify.error("Printer API error");
            console.log(error.response.statusText);
          } else if (error) {
            this.$alertify.error("Printer not connected")
          }
          this.addStickerLog(this.loginput);
        })
      this.isLoading = false;
    },
    addStickerLog(input) {
      console.log("in log");
      axios({
        method: "POST",
        url: apiUrl.api_url + 'external/RTO/sticker/add/log',
        data: input
      })
        .then(result => {
          if (result.data.code == 200) {
            this.$alertify.success('Log Created Successfully');
            // this.reset();
          } else {
            this.$alertify.error(result.data.message);
          }
        }, error => {
          this.$alertify.error(error.message);
        })
    },
    /* Printing Done */
    closeModelReturnToPrintPage (){
      this.isShowReprintPopUpReprint = false
      let RequestForNewPrint = {
        "hubid": this.hubid,
        "requestedby": this.userid,
        "requestsource": 'lm',
        "shippingid": this.propsParam.shipmentDetails.ShippingId.trim().toUpperCase(),
        "shipmenttype": this.shipResponseData.shipmentType,
        "centertype": this.shipResponseData.centerType,
        "istlqceligible": this.shipResponseData.isTlqcShipment,
        "istlqcdone": this.shipResponseData.hasTlqcProcessCompleted,
        "userrole": this.userrole,
        "action": 'printfailed',
        "isDtoPaperSheetOnOrOff" : this.isDtoPaperSheetOnOrOff,
        "approvalrole":this.shipResponseData.allowedReprintRole
      };
      updateShipmentStatusForOnePager(RequestForNewPrint, (result) => {
        try {
          /* reset All Fields */
          if(this.actionStatus != 'linkingpending'){
            this.reset();
          }
          this.isLoading = false;
          if (result.data.code == 200) {
            this.$alertify.success(result.data.message);
            this.isShowReprintPopUpReprint = false
          } else {
            this.$alertify.error(result.data.message);
            this.isShowReprintPopUpReprint = false
          }
          setTimeout(() => {
            window.location.reload();
          }, 2000); // 10000 milliseconds = 10 seconds
        } catch (error) {
          console.log('result------', error.message);
        }
      })
    },
    cancelReprint(){
      this.isShowReprintPopUpReprint = false;
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/components/RVPPrintLabelInscanv2/RVPPrintLabelInscanv2.component.js